import * as types from '../actionTypes/systemParameter'

let defaultState = {
  systemParameters: [],
  faqUrl: '',
  complaintsUrl: '',
  homePageText: '',
  registrationText: '',
  annualReturnPageText: '',
  annualReturnStartYear: null,
  dpcNotificationEmail: ''
}

const systemParameterReducer = (state = defaultState, action) => {
  if (action.type === types.GET_SYSTEM_PARAMETERS) {
    return {
      ...state,
      systemParameters: action.systemParameters
    }
  } else if (action.type === types.GET_FAQ_URL) {
    return {
      ...state,
      faqUrl: action.faqUrl
    }
  } else if (action.type === types.GET_COMPLAINTS_URL) {
    return {
      ...state,
      complaintsUrl: action.complaintsUrl
    }
  }else if (action.type === types.GET_HOME_PAGE_TEXT) {
    return {
      ...state,
      homePageText: action.homePageText
    }
  } else if (action.type === types.GET_ANNUAL_RETURN_START_YEAR) {
    return {
      ...state,
      annualReturnStartYear: action.annualReturnStartYear
    }
  } else if (action.type === types.GET_REGISTRATION_TEXT) {
    return {
      ...state,
      registrationText: action.registrationText
    }
  } else if (action.type === types.GET_ANNUAL_RETURN_PAGE_TEXT) {
    return {
      ...state,
      annualReturnPageText: action.annualReturnPageText
    }
  } else if (action.type === types.GET_DPC_NOTIFICATION_EMAIL) {
    return {
      ...state,
      dpcNotificationEmail: action.dpcNotificationEmail
    }
  } else {
    return {
      ...state
    }
  }
}

export default systemParameterReducer



// WEBPACK FOOTER //
// ./src/reducers/systemParameter.js